const dateTime = new Intl.DateTimeFormat('fa-IR', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
});

const dateOnly = new Intl.DateTimeFormat('fa-IR', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

const timeOnly = new Intl.DateTimeFormat('fa-IR', {
  hour: '2-digit',
  minute: '2-digit',
});

export function formatDateTime(value) {
  if (!value) return '—';
  return dateTime.format(new Date(value));
}

/** فقط تاریخ، بدون ساعت — برای برگه‌ی چاپی که ساعتِ پذیرش رویش بی‌معناست. */
export function formatDate(value) {
  if (!value) return '—';
  return dateOnly.format(new Date(value));
}

export function formatTime(value) {
  if (!value) return '—';
  return timeOnly.format(new Date(value));
}

/** ثانیه را به شکل خوانا در می‌آورد: «۱۲ دقیقه و ۳۰ ثانیه». */
export function formatDuration(seconds) {
  if (seconds === null || seconds === undefined) return '—';
  const total = Math.max(0, Math.round(seconds));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const rest = total % 60;

  const parts = [];
  if (hours) parts.push(`${hours} ساعت`);
  if (minutes) parts.push(`${minutes} دقیقه`);
  if (!hours && rest) parts.push(`${rest} ثانیه`);
  return parts.length ? parts.join(' و ') : 'کمتر از یک ثانیه';
}

export function formatToman(value) {
  if (value === null || value === undefined) return '—';
  return `${new Intl.NumberFormat('fa-IR').format(value)} تومان`;
}

export function formatNumber(value) {
  if (value === null || value === undefined) return '۰';
  return new Intl.NumberFormat('fa-IR').format(value);
}

/** تاریخ به شکل YYYY-MM-DD در وقت محلی — همان چیزی که فیلترهای سرور می‌خواهند. */
export function toIsoDate(date) {
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

const persianParts = new Intl.DateTimeFormat('en-US-u-ca-persian', {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
});

/**
 * اولین روز ماه شمسیِ جاری، به شکل ISO.
 *
 * فیش کارانه ماه شمسی است نه میلادی. به‌جای آوردن یک کتابخانه‌ی تقویم، روزِ
 * شمسیِ امروز را از Intl می‌گیریم و همان تعداد روز عقب می‌رویم — بدون
 * وابستگی و بدون خطای تبدیل دستی.
 */
export function jalaliMonthStart(reference = new Date()) {
  const day = Number(
    persianParts.formatToParts(reference).find((part) => part.type === 'day').value
  );
  const start = new Date(reference);
  start.setHours(0, 0, 0, 0);
  start.setDate(start.getDate() - (day - 1));
  return start;
}

/** نام ماه شمسی جاری، برای برچسب دکمه. */
export function jalaliMonthLabel(reference = new Date()) {
  return new Intl.DateTimeFormat('fa-IR', { year: 'numeric', month: 'long' }).format(
    reference
  );
}

/** مدت سپری‌شده از یک زمان، برای شمارنده‌ی زنده. */
export function elapsedSince(iso) {
  if (!iso) return 0;
  return Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
}

/**
 * جدا کردن یک مقدار پویا از متن دور و برش — نسخه‌ی رشته‌ایِ `<bdi>`.
 *
 * در JSX همیشه `<bdi>` بهتر است. ولی جاهایی هست که عنصر HTML نمی‌شود
 * گذاشت: عنوان مودال، `window.confirm`، پیام toast، عنوان تب. آنجا همان
 * کار با دو نویسه‌ی خودِ یونیکد انجام می‌شود:
 *
 *   U+2068 FSI — «از اینجا یک تکه‌ی مستقل شروع می‌شود؛ جهتش را از اولین
 *                 حرفِ خودش بگیر»
 *   U+2069 PDI — «تمام شد؛ به جهت قبلی برگرد»
 *
 * بدون این‌ها، نامِ لاتینِ داخل «...» فارسی، گیومه‌ها را با خودش جابه‌جا
 * می‌کند و «Dr. Smith» به شکل «Dr. Smith« دیده می‌شود.
 *
 * نویسه‌ها نامرئی‌اند و در کپی‌کردنِ متن هم بی‌آزارند.
 */
export function isolate(value) {
  const text = value == null ? '' : String(value);
  // با escape نوشته شده‌اند نه مستقیم: نویسه‌ی نامرئی داخل سورس، همان
  // چیزی است که یک روز بی‌صدا از کپی‌وپیست می‌افتد و کسی نمی‌فهمد چرا.
  return text ? `\u2068${text}\u2069` : '';
}
